export default __webpack_public_path__ + "static/media/4600.88d9c2b5.png";